import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import './sidebar.css';

import analytics from '../../../utils/analytics';

class Sidebar extends Component {
  render() {
    return (
      <div className="cp-sidebar">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <h4>Frequency & Generation</h4>
            <small>4 sec data</small>
            <ul>
              <li>
                <NavLink
                  to="/core-data/generationlineduid"
                  className="nav-link"
                  activeClassName="active"
                  onClick={() =>
                    analytics.event('Sidebar', 'click', {
                      target: 'generationlineduid',
                    })
                  }
                >
                  Line chart (by duid)
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <h4>Portland Smelter</h4>
            <small>4sec/5min/30min/1hour/1day data</small>
            <ul>
              <li>
                <NavLink
                  to="/core-data/portlandline"
                  className="nav-link"
                  activeClassName="active"
                  onClick={() =>
                    analytics.event('Sidebar', 'click', {
                      target: 'portlandline',
                    })
                  }
                >
                  Line chart
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <h4>Frequency</h4>
            <small>5 min data</small>
            <ul>
              <li>
                <NavLink
                  to="/core-data/frequencyheatmap"
                  className="nav-link"
                  activeClassName="active"
                  onClick={() =>
                    analytics.event('Sidebar', 'click', {
                      target: 'frequencyheatmap',
                    })
                  }
                >
                  Heat map
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/core-data/frequencyline5min"
                  className="nav-link"
                  activeClassName="active"
                  onClick={() =>
                    analytics.event('Sidebar', 'click', {
                      target: 'frequencyline5min',
                    })
                  }
                >
                  Line chart
                </NavLink>
              </li>
            </ul>
            <small>4 sec data</small>
            <ul>
              <li>
                <NavLink
                  to="/core-data/frequencyline"
                  className="nav-link"
                  activeClassName="active"
                  onClick={() =>
                    analytics.event('Sidebar', 'click', {
                      target: 'frequencyline',
                    })
                  }
                >
                  Line chart
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/core-data/frequencylineduid"
                  className="nav-link"
                  activeClassName="active"
                  onClick={() =>
                    analytics.event('Sidebar', 'click', {
                      target: 'frequencylineduid',
                    })
                  }
                >
                  Line chart (by duid)
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/views/components/sidebar/Sidebar.jsx